<template>
  <div class="dtp">
    <label :for="`dtp-field-${fieldId}`">
      {{ label }}
    </label>

    <div :id="`dtp-field-${fieldId}`"
         class="dtp__value">
      <b-form-datepicker v-model="date"
                         class="form-control dtp__component dtp__component--date"
                         placeholder="Select date"
                         data-hj-suppress></b-form-datepicker>

      <b-form-timepicker v-model="time"
                         class="form-control dtp__component dtp__component--time"
                         placeholder="Select time"
                         data-hj-suppress></b-form-timepicker>
    </div>
  </div>
</template>

<script>
import { debounce } from "lodash";

export default {
  name: "DateTimePicker",

  props: {
    value: {
      type: String,
      default: null,
    },

    fieldId: {
      type: String,
      required: true,
    },

    label: {
      type: String,
      default: null,
    },
  },

  data () {
    return {
      date: null,
      time: null,
    };
  },

  watch: {
    value: {
      immediate: true,
      handler ( val ) {
        if ( !val ) {
          this.date = null;
          this.time = null;
        } else if ( typeof ( val ) === "string" ) {
          const vals = val.split( "T" );
          // eslint-disable-next-line prefer-destructuring
          this.date = vals[0];
          // eslint-disable-next-line prefer-destructuring
          this.time = vals[1];
        }

        this.mutable = val;
      },
    },
    date: {
      handler () {
        this.update();
      },
    },
    time: {
      handler () {
        this.update();
      },
    },
  },

  methods: {
    update () {
      debounce( this.$emit( "input", `${this.date}T${this.time}` ), 1000 );
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../Styles/utils/dimensions.less";

.dtp {
  &__value {
    margin-top: -10px;
  }

  &__component {
    margin-top: 10px;
  }

  @media ( min-width: @md ) {
    &__value {
      display: flex;
      flex-direction: row;
      margin-left: -10px;
    }

    &__component {
      margin-left: 10px;

      &--date {
        flex: 1 1 auto;
      }

      &--time {
        flex: 0 0 160px;
      }
    }
  }
}
</style>
